import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import { DashboardFilter, DashboardIncomeChart, KPIDashboardTabs } from "components/organisms";
import { DashboardSummary, OccupancyChart, ChannelDistribution, PageHeader } from "components/molecules";

import {
	getDashboardReport,
	getDashboardYearReport,
	getDashboardYearReportLoading,
	getDashboardKPIData,
} from "state/modules/dashboard";

const Dashboard = () => {
	const dispatch = useDispatch();

	const isYearReportLoading = useSelector(getDashboardYearReportLoading);
	const kpiData = useSelector(getDashboardKPIData);

	useEffect(() => {
		dispatch(getDashboardReport());
		dispatch(getDashboardYearReport());
	}, [dispatch]);

	return (
		<div className="w-full h-screen overflow-auto bg-background sm:pb-24 md:h-auto md:min-h-screen">
			<PageHeader
				title="Dashboard"
				description="Overview of your property performance and key metrics."
			/>
			<div className="mb-4">
				<DashboardFilter />
			</div>
			<div className="mb-4 z-0">
				<DashboardSummary />
			</div>
			<div className="mb-4">
				<ChannelDistribution />
			</div>
			<div className="w-full grid grid-cols-1 min-[1120px]:grid-cols-[1fr_320px] gap-4">
				<DashboardIncomeChart isLoading={isYearReportLoading} />
				<OccupancyChart isLoading={isYearReportLoading} />
			</div>
			{kpiData.length > 0 && (
				<div className="w-full mt-8">
					<KPIDashboardTabs />
				</div>
			)}
		</div>
	);
};

export default Dashboard;
